import { useAppConfig } from '../../hooks/useAppConfig';

export default function Footer() {
  const appConfig = useAppConfig();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 flex items-center justify-center">
                <img 
                  src={appConfig.logo} 
                  alt={`${appConfig.name} Logo`} 
                  className="w-full h-full object-contain"
                />
              </div>
              <h4 className="text-2xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                {appConfig.name}
              </h4>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              {appConfig.description}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-indigo-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-indigo-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-indigo-600 transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-indigo-600 transition-colors cursor-pointer">
                <i className="ri-youtube-fill"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h5 className="text-lg font-semibold mb-6">Quick Links</h5>
            <ul className="space-y-3">
              <li><a href="#features" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Features</a></li>
              <li><a href="#gallery" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Gallery</a></li>
              <li><a href="#download" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Download</a></li>
              <li><a href={appConfig.playStoreUrl} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Google Play</a></li>
            </ul>
          </div>
          
          <div>
            <h5 className="text-lg font-semibold mb-6">Legal & Support</h5>
            <ul className="space-y-3">
              <li>
                <a 
                  href={appConfig.legalLinks.privacyPolicy}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a 
                  href={appConfig.legalLinks.termsOfService}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Terms of Service
                </a>
              </li>
              <li><a href="mailto:askourapp@gmail.com" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Help Center</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 mb-4 md:mb-0">
              © {currentYear} {appConfig.name}. All rights reserved. | Krevia Studios LLP
            </p>
            <div className="flex items-center space-x-4">
              <span className="text-gray-500 text-sm">Made with ❤️ in India</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
